import React from 'react';
import { CLIMATEPLANS_DATA_USE_NOTICE } from '../../constants/dataUsePolicy';
import './Footer.css';

export const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer" role="contentinfo">
      <div className="footer-content">
        <div className="footer-section">
          <h4>Partners</h4>
          <p>
            Seed funding provided by the University of California Office of the President&apos;s{' '}
            <a
              href="https://uckeepresearching.org/california-climate-action/"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-link"
              aria-label="California Climate Action Initiative (opens in new window)"
            >
              California Climate Action Initiative
            </a>
            . Members include the California Air Resources Board, City and County of San Francisco,{' '}
            <a
              href="https://www.stopwaste.org/"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-link"
              aria-label="StopWaste.org (opens in new window)"
            >
              StopWaste.org
            </a>
            , and{' '}
            <a
              href="https://coolclimate.org/members"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-link"
              aria-label="other CoolClimate members (opens in new window)"
            >
              other CoolClimate members
            </a>
            .
          </p>
        </div>
      </div>

      <div className="footer-bottom">
        <p className="footer-data-use-notice">{CLIMATEPLANS_DATA_USE_NOTICE}</p>
        <p>&copy; {currentYear} ClimatePlans.org. All rights reserved.</p>
      </div>
    </footer>
  );
};
